import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ["shortText", "longText", "moreButton", "lessButton"]

  connect() {
    this.showLess()
  }

  showMore() {
    this.shortTextTarget.classList.add('hidden')
    this.moreButtonTarget.classList.add('hidden')
    this.longTextTarget.classList.remove('hidden')
    this.lessButtonTarget.classList.remove('hidden')
    this.moreButtonTarget.setAttribute('aria-expanded', 'true')
    this.lessButtonTarget.setAttribute('aria-expanded', 'true')
  }

  showLess() {
    this.shortTextTarget.classList.remove('hidden')
    this.moreButtonTarget.classList.remove('hidden')
    this.longTextTarget.classList.add('hidden')
    this.lessButtonTarget.classList.add('hidden')
    this.moreButtonTarget.setAttribute('aria-expanded', 'false')
    this.lessButtonTarget.setAttribute('aria-expanded', 'false')
  }
}
